export default __webpack_public_path__ + "static/media/3134.182bd310.jpg";